import { registerHandler } from "@utils/pixels/handler";
import { toSha256 } from "@utils/cryptography";

declare const roktLauncher: any;

export default function registerHandlers() {
  registerHandler("purchase", async ({ email, order, plan }) => {
    let conversionType = "Free";
    const {
      has_trial,
      trial_duration,
      userSelectedTrialFee,
      discounted_plan_price,
    } = plan;
    if (!has_trial || trial_duration < 1 || userSelectedTrialFee > 0) {
      conversionType = "Paid";
    }

    const encryptedEmail = await toSha256(email);
    const pixelData = {
      emailsha256: encryptedEmail,
      amount: discounted_plan_price || 0,
      currency: plan.currency ? plan.currency : "USD",
      confirmationref: order.subscriptionId,
      conversiontype: conversionType,
    };
    if (roktLauncher) {
      roktLauncher.selectPlacements({
        attributes: pixelData,
      });
    }
  });
}
